import { Directive, HostListener, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

type TooltipVariant = 'dark' | 'light';

@Directive({
  selector: '[matTooltip]',
  standalone: true,
})
export class MatTooltipAddonsDirective {
  @HostListener('click') onClick() {
    if (this.useClickListener) {
      this.matTooltip.show(0);
    }
  }

  @Input() useClickListener!: boolean;

  @Input() get variant() {
    return this._variant;
  }
  set variant(value: TooltipVariant) {
    this.matTooltip.tooltipClass =
      value === 'light' ? 'mat-mdc-tooltip-light' : 'mat-mdc-tooltip-dark';
    this._variant = value;
  }

  private _variant: TooltipVariant = 'dark';
  constructor(private matTooltip: MatTooltip) {}
}
